import React from 'react'

export default function Loop({ className }) {
  return (
    <svg viewBox="0 0 20 19" className={className}>
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M19.73 3.831l-4.114 2.99c-.306.222-.739.007-.739-.368V4.698H5.466a.75.75 0 00-.753.741v2.964c0 .682-.561 1.235-1.254 1.235a1.245 1.245 0 01-1.255-1.235V5.439c0-1.77 1.464-3.211 3.262-3.211h9.411V.474c0-.375.433-.59.739-.368l4.114 2.99a.453.453 0 010 .735zM5.344 11.745v1.757h9.409a.748.748 0 00.753-.741V9.797c0-.682.562-1.235 1.255-1.235.693 0 1.254.553 1.254 1.235v2.964c0 1.77-1.463 3.211-3.262 3.211H5.344v1.752c0 .375-.433.59-.74.368L.49 15.102a.452.452 0 010-.735l4.114-2.99c.307-.222.74-.007.74.368z"
      />
    </svg>
  )
}
